<script setup lang="ts">
/**
 * 셸 없는 중앙정렬 레이아웃 — login/signup/verify·예외(error) 페이지용.
 * 풀 GNB 는 없지만 상단 브랜드 로고로 명시적 "왔던 축" 복귀 경로를 제공한다
 * (인증 화면이 막다른 길이 되지 않도록 — 프로토타입 login.html 의 로고 홈링크 의도 계승).
 * 카드형 폼은 각 페이지가 소유하며 로고 아래 중앙에 배치된다.
 */
import { computed } from 'vue';
import { RouterLink, useRoute } from 'vue-router';

import BrandLogo from '#/components/layout/BrandLogo.vue';
import { brand } from '#/config/brand';

/**
 * 로고 복귀지 — 출발한 축으로 돌려보낸다(탈출구가 커머스로 고정되지 않도록).
 * `redirect` 쿼리(로그인 유도 시 셸이 붙인 origin — 워크스페이스=/analysis)를 재사용하고,
 * 없으면 커머스 홈('/'). 로그인 성공 복귀(LoginPage.resolveDestination)와 같은 origin 소스라
 * "로고로 나가기"와 "로그인 후 복귀"의 목적지가 일치한다. 단 로고는 읽기만 하고 소비하지 않는다.
 */
const route = useRoute();
const backTo = computed(() => {
  const redirect = route.query.redirect;
  return typeof redirect === 'string' ? redirect : '/';
});
</script>

<template>
  <div class="flex min-h-screen flex-col bg-bg-2 px-[18px] py-8 text-body md:py-10">
    <!-- 상단 브랜드 로고 → 왔던 축(redirect 쿼리) 또는 홈(/). 인증 화면의 명시적 탈출구. -->
    <div class="flex justify-center">
      <RouterLink
        :to="backTo"
        class="inline-flex rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent"
        :aria-label="`${brand.name} 홈으로`"
      >
        <BrandLogo />
      </RouterLink>
    </div>

    <!-- 폼 카드 — 로고 아래 남은 공간의 중앙 -->
    <div class="flex flex-1 flex-col items-center justify-center py-8">
      <slot />
    </div>
  </div>
</template>
